const C = (e) => (t = {}, r) => {
  switch (r.type) {
    case "RECORD_OBJECT:CLEAR_RECORD": {
      const { recordId: E } = r, T = { ...t };
      return delete T[E], T;
    }
    case "RECORD_OBJECT:CLEAR_ALL_RECORDS":
      return {};
    case "RECORD_OBJECT:ACTION": {
      const { recordId: E, action: T } = r;
      return {
        ...t,
        [E]: e(t[E], T)
      };
    }
    default:
      return t;
  }
}, p = () => ({
  recordAction: (e, t) => ({
    type: "RECORD_OBJECT:ACTION",
    action: t,
    recordId: e
  }),
  clearRecord: (e) => ({
    type: "RECORD_OBJECT:CLEAR_RECORD",
    recordId: e
  }),
  clearAllRecords: () => ({
    type: "RECORD_OBJECT:CLEAR_ALL_RECORDS"
  })
}), B = (e, t) => (r, E) => {
  let T = r ?? t(void 0, {});
  return !d(E) || e !== E.reducerId || E.type !== "REDUCER_ID_GATE:ACTION" ? T : t(T, E.action);
}, f = (e, t) => ({
  type: "REDUCER_ID_GATE:ACTION",
  action: t,
  reducerId: e
}), d = (e) => !!e.action && e.type === "REDUCER_ID_GATE:ACTION" && typeof e.reducerId == "string", i = (e, t) => (...r) => ({
  type: "REDUCER_ID_GATE:ACTION",
  reducerId: e,
  action: t(...r)
}), V = (e, t) => {
  const r = {};
  for (const E in t) {
    const T = t[E];
    r[E] = i(
      e,
      T
    );
  }
  return r;
}, M = (e) => ({
  setValues: (t) => ({
    type: "COMMIT_REDUCER.SET_VALUES",
    id: e,
    values: t
  }),
  commitValues: () => ({
    type: "COMMIT_REDUCER.COMMIT_VALUES",
    id: e
  }),
  clearValues: () => ({
    type: "COMMIT_REDUCER.CLEAR",
    id: e
  })
}), w = (e, t) => (r = t, E) => {
  if (E.id !== e)
    return r;
  switch (E.type) {
    case "COMMIT_REDUCER.SET_VALUES": {
      const { values: T } = E;
      return {
        ...r,
        workspace: {
          ...r.workspace,
          ...T
        }
      };
    }
    case "COMMIT_REDUCER.CLEAR":
      return {
        ...r,
        workspace: {
          ...t.workspace
        }
      };
    case "COMMIT_REDUCER.COMMIT_VALUES":
      return {
        ...r,
        committed: {
          ...r.workspace
        }
      };
    default:
      return r;
  }
}, h = (e, t) => ({
  getWorkspaceValues: (r) => t(r, e).workspace,
  getCommittedValues: (r) => t(r, e).committed
}), U = () => ({
  addAtEnd: (e) => ({ type: "ENTITY_LIST:ADD_AT_END", entity: e }),
  addAtStart: (e) => ({
    entity: e,
    type: "ENTITY_LIST:ADD_AT_START"
  }),
  clearList: () => ({ type: "ENTITY_LIST:CLEAR_LIST" }),
  removeFirst: () => ({ type: "ENTITY_LIST:REMOVE_FIRST" }),
  removeLast: () => ({ type: "ENTITY_LIST:REMOVE_LAST" }),
  removeAtIndex: (e) => ({
    type: "ENTITY_LIST:REMOVE_AT_INDEX",
    index: e
  }),
  removeByFieldMatch: (e) => ({
    type: "ENTITY_LIST:REMOVE_BY_FIELD_MATCH",
    fields: e
  }),
  remove: (e) => ({ type: "ENTITY_LIST:REMOVE", entity: e }),
  setList: (e) => ({ type: "ENTITY_LIST:SET_LIST", list: e }),
  toggle: (e) => ({ type: "ENTITY_LIST:TOGGLE", entity: e }),
  actionByFieldsMatch: (e, t) => ({
    type: "ENTITY_LIST:ACTION_BY_FIELDS_MATCH",
    fields: e,
    action: t
  }),
  actionByIndex: (e, t) => ({
    type: "ENTITY_LIST:ACTION_BY_INDEX",
    index: e,
    action: t
  }),
  actionOnAll: (e) => ({
    type: "ENTITY_LIST:ACTION_ON_ALL",
    action: e
  })
}), c = (e, t) => {
  const r = Object.keys(t);
  if (r.length === 0)
    return !1;
  for (let E = 0; E < r.length; E++) {
    const T = r[E];
    if (e[T] !== t[T])
      return !1;
  }
  return !0;
}, m = (e) => (t = [], r) => {
  switch (r.type) {
    case "ENTITY_LIST:SET_LIST": {
      const { list: E } = r;
      return E;
    }
    case "ENTITY_LIST:CLEAR_LIST":
      return [];
    case "ENTITY_LIST:ADD_AT_END": {
      const { entity: E } = r;
      return [...t, E];
    }
    case "ENTITY_LIST:ADD_AT_START": {
      const { entity: E } = r;
      return [E, ...t];
    }
    case "ENTITY_LIST:REMOVE_FIRST": {
      if (t.length === 0)
        throw new Error("Cannot remove, list is empty.");
      const [, ...E] = t;
      return E;
    }
    case "ENTITY_LIST:REMOVE_LAST": {
      if (t.length === 0)
        throw new Error("Cannot remove, list is empty.");
      const E = [...t];
      return E.pop(), E;
    }
    case "ENTITY_LIST:REMOVE_AT_INDEX": {
      const { index: E } = r;
      if (E < 0)
        throw new Error("Index is lower than 0.");
      if (E >= t.length)
        throw new Error("Index is outside of list bounds.");
      const T = [...t];
      return T.splice(E, 1), T;
    }
    case "ENTITY_LIST:REMOVE_BY_FIELD_MATCH": {
      const { fields: E } = r;
      return t.filter((T) => !c(T, E));
    }
    case "ENTITY_LIST:REMOVE": {
      const { entity: E } = r;
      return t.filter((T) => T !== E);
    }
    case "ENTITY_LIST:TOGGLE": {
      const { entity: E } = r, T = t.findIndex(
        (n) => n === E || c(n, E)
      );
      if (T >= 0) {
        const n = [...t];
        return n.splice(T, T), n;
      } else
        return [...t, E];
    }
    case "ENTITY_LIST:ACTION_BY_FIELDS_MATCH": {
      const { fields: E, action: T } = r;
      if (!e)
        throw new Error(
          "No reducer specified, unable to handle 'actionByFieldsMatch'."
        );
      return t.map(
        (n) => c(n, E) ? e(n, T) : n
      );
    }
    case "ENTITY_LIST:ACTION_BY_INDEX": {
      const { index: E, action: T } = r;
      if (!e)
        throw new Error(
          "No reducer specified, unable to handle 'actionByIndex'."
        );
      return t.map(
        (n, o) => E === o ? e(n, T) : n
      );
    }
    case "ENTITY_LIST:ACTION_ON_ALL": {
      const { action: E } = r;
      if (!e)
        throw new Error(
          "No reducer specified, unable to handle 'actionByIndex'."
        );
      return t.map((T) => e(T, E));
    }
    default:
      return t;
  }
}, v = (e) => ({
  getList: (t) => e(t)
}), S = { entities: {} }, I = () => (e = S, t) => {
  switch (t.type) {
    case "ENTITY_BY_ID:SET_ENTITY": {
      const { entity: r } = t;
      return {
        ...e,
        entities: {
          ...e.entities,
          [r.id]: r
        }
      };
    }
    case "ENTITY_BY_ID:SET_ENTITY_FIELDS": {
      const { id: r, fields: E } = t;
      return {
        ...e,
        entities: {
          ...e.entities,
          [r]: {
            ...e.entities[r],
            ...E
          }
        }
      };
    }
    case "ENTITY_BY_ID:CLEAR_ALL_ENTITIES":
      return {
        ...e,
        entities: {}
      };
    case "ENTITY_BY_ID:CLEAR_ENTITY": {
      const { id: r } = t, E = {
        ...e.entities
      };
      return delete E[r], {
        ...e,
        entities: E
      };
    }
    default:
      return e;
  }
}, s = () => ({
  setEntity: (e) => ({
    type: "ENTITY_BY_ID:SET_ENTITY",
    entity: e
  }),
  setEntityFields: (e, t) => ({
    type: "ENTITY_BY_ID:SET_ENTITY_FIELDS",
    id: e,
    fields: t
  }),
  clearEntity: (e) => ({
    type: "ENTITY_BY_ID:CLEAR_ENTITY",
    id: e
  }),
  clearAllEntities: () => ({
    type: "ENTITY_BY_ID:CLEAR_ALL_ENTITIES"
  })
}), _ = (e) => ({
  getState: e
}), b = (e) => {
  const t = e;
  return (r = t, E) => {
    switch (E.type) {
      case "ENTITY:SET_ENTITY": {
        const { entity: T } = E;
        return T;
      }
      case "ENTITY:SET_ENTITY_FIELDS": {
        const { fields: T } = E;
        return {
          ...r,
          ...T
        };
      }
      default:
        return r;
    }
  };
}, F = () => ({
  setEntity: (e) => ({
    type: "ENTITY:SET_ENTITY",
    entity: e
  }),
  setEntityFields: (e) => ({
    type: "ENTITY:SET_ENTITY_FIELDS",
    fields: e
  })
}), g = (e) => ({
  getEntity: (t) => e(t)
}), R = () => I(), u = () => s(), A = (e) => _(e), x = (e) => {
  const t = R(), r = u(), E = A(e);
  return {
    reducer: t,
    actions: r,
    selectors: E
  };
}, G = (e) => {
  const t = I(), r = _(
    e
  ), E = s();
  return {
    reducer: t,
    selectors: r,
    actions: E
  };
}, k = (e, t) => {
  const r = {
    id: t,
    editable: e,
    persisted: e
  };
  return (E = r, T) => {
    switch (T.type) {
      case "EDITABLE_ENTITY:SET_ENTITY_ID": {
        const { id: n } = T;
        return {
          ...E,
          id: n
        };
      }
      case "EDITABLE_ENTITY:SET_ENTITY": {
        const { entity: n } = T;
        return {
          ...E,
          persisted: n,
          editable: n
        };
      }
      case "EDITABLE_ENTITY:SET_PERSISTED_ENTITY": {
        const { entity: n } = T;
        return {
          ...E,
          persisted: n
        };
      }
      case "EDITABLE_ENTITY:SET_EDITABLE_ENTITY": {
        const { entity: n } = T;
        return {
          ...E,
          editable: n
        };
      }
      case "EDITABLE_ENTITY:SET_EDITABLE_ENTITY_FIELDS": {
        const { fields: n } = T;
        return {
          ...E,
          editable: {
            ...E.editable,
            ...n
          }
        };
      }
      case "EDITABLE_ENTITY:REVERT_EDITABLE_ENTITY":
        return {
          ...E,
          editable: E.persisted
        };
      case "EDITABLE_ENTITY:COMMIT_EDITABLE_ENTITY_TO_PERSISTED":
        return {
          ...E,
          persisted: E.editable
        };
      default:
        return E;
    }
  };
}, J = () => ({
  setEntityId: (e) => ({
    type: "EDITABLE_ENTITY:SET_ENTITY_ID",
    id: e
  }),
  setEntity: (e) => ({ type: "EDITABLE_ENTITY:SET_ENTITY", entity: e }),
  setPersistedEntity: (e) => ({
    type: "EDITABLE_ENTITY:SET_PERSISTED_ENTITY",
    entity: e
  }),
  setEditableEntity: (e) => ({
    type: "EDITABLE_ENTITY:SET_EDITABLE_ENTITY",
    entity: e
  }),
  setEditableEntityFields: (e) => ({
    type: "EDITABLE_ENTITY:SET_EDITABLE_ENTITY_FIELDS",
    fields: e
  }),
  revertEditableEntity: () => ({
    type: "EDITABLE_ENTITY:REVERT_EDITABLE_ENTITY"
  }),
  commitEditableEntityToPersisted: () => ({
    type: "EDITABLE_ENTITY:COMMIT_EDITABLE_ENTITY_TO_PERSISTED"
  })
}), L = (e = []) => ({
  selectedIds: e
}), l = L(), D = (e = l) => (t = e, r) => {
  switch (r.type) {
    case "SELECTED_IDS:SET_SELECTED_IDS": {
      const { selectedIds: E } = r;
      return {
        ...t,
        selectedIds: E
      };
    }
    case "SELECTED_IDS:CLEAR_SELECTED_IDS":
      return {
        ...t,
        selectedIds: []
      };
    default:
      return t;
  }
}, P = D(), y = () => ({
  setSelectedIds: (e) => ({
    selectedIds: e,
    type: "SELECTED_IDS:SET_SELECTED_IDS"
  }),
  clearSelectedIds: () => ({
    type: "SELECTED_IDS:CLEAR_SELECTED_IDS"
  })
}), H = y(), X = (e) => ({
  getState: e
}), a = {
  ids: void 0
}, N = () => (e = a, t) => {
  switch (t.type) {
    case "SORT_ORDER_BY_ID:SET_SORT_ORDER":
      return {
        ...e,
        ids: t.ids
      };
    case "SORT_ORDER_BY_ID:CLEAR_SORT_ORDER":
      return {
        ...e,
        ids: void 0
      };
    default:
      return e;
  }
}, j = N(), O = () => ({
  setSortOrder: (e) => ({
    ids: e,
    type: "SORT_ORDER_BY_ID:SET_SORT_ORDER"
  }),
  clearSortOrder: () => ({
    type: "SORT_ORDER_BY_ID:CLEAR_SORT_ORDER"
  })
}), W = O(), $ = (e) => ({
  getSortOrderByIdState: (t) => e(t),
  getSortOrder: (t) => e(t).ids
}), q = (e = void 0, t = !1) => ({
  sortBy: e,
  desc: t
}), z = (e = { sortBy: void 0, desc: !1 }) => (t = e, r) => {
  switch (r.type) {
    case "SORT_ORDER:SET_SORT_BY": {
      const { sortBy: E, desc: T } = r;
      return {
        ...t,
        sortBy: E,
        desc: T
      };
    }
    case "SORT_ORDER:CLEAR_SORT_ORDER":
      return {
        ...t,
        sortBy: void 0,
        desc: !1
      };
    default:
      return t;
  }
}, K = () => ({
  sortBy: (e, t) => ({
    desc: t,
    sortBy: e,
    type: "SORT_ORDER:SET_SORT_BY"
  }),
  clearSortOrder: () => ({
    type: "SORT_ORDER:CLEAR_SORT_ORDER"
  })
}), Q = (e) => ({
  getState: e
}), Y = { values: {} }, Z = (e = Y) => (t = e, r) => {
  switch (r.type) {
    case "VALUE_BY_ID:SET_VALUE": {
      const { id: E, value: T } = r;
      return {
        ...t,
        values: {
          ...t.values,
          [E]: T
        }
      };
    }
    case "VALUE_BY_ID:CLEAR_ALL_VALUES":
      return {
        ...t,
        values: {}
      };
    case "VALUE_BY_ID:CLEAR_VALUE": {
      const { id: E } = r, T = {
        ...t.values
      };
      return delete T[E], {
        ...t,
        values: T
      };
    }
    default:
      return t;
  }
}, ee = () => ({
  setValue: (e, t) => ({
    type: "VALUE_BY_ID:SET_VALUE",
    id: e,
    value: t
  }),
  clearValue: (e) => ({
    type: "VALUE_BY_ID:CLEAR_VALUE",
    id: e
  }),
  clearAllValues: () => ({
    type: "VALUE_BY_ID:CLEAR_ALL_VALUES"
  })
}), te = (e) => ({
  getState: e
});
export {
  w as createCommitReducer,
  M as createCommitReducerActions,
  h as createCommitReducerSelectors,
  J as createEditableEntityActions,
  k as createEditableEntityReducer,
  F as createEntityActions,
  s as createEntityByIdActions,
  I as createEntityByIdReducer,
  _ as createEntityByIdSelectors,
  u as createEntityCrudStatusActions,
  R as createEntityCrudStatusReducer,
  x as createEntityCrudStatusRedux,
  A as createEntityCrudStatusSelectors,
  U as createEntityListActions,
  m as createEntityListReducer,
  v as createEntityListSelectors,
  b as createEntityReducer,
  g as createEntitySelectors,
  G as createModifiedFieldRedux,
  p as createRecordObjectActions,
  C as createRecordObjectReducer,
  y as createSelectedIdsActions,
  D as createSelectedIdsReducer,
  L as createSelectedIdsReducerInitialState,
  X as createSelectedIdsSelectors,
  K as createSortOrderActions,
  O as createSortOrderByIdActions,
  N as createSortOrderByIdReducer,
  $ as createSortOrderByIdSelectors,
  z as createSortOrderReducer,
  q as createSortOrderReducerInitialState,
  Q as createSortOrderSelectors,
  ee as createValueByIdActions,
  Z as createValueByIdReducer,
  te as createValueByIdSelectors,
  S as entityByIdInitialState,
  B as reducerIdGate,
  f as reducerIdGateAction,
  H as selectedIdsActions,
  P as selectedIdsReducer,
  W as sortOrderByIdActions,
  j as sortOrderByIdReducer,
  Y as valueByIdInitialState,
  i as wrapActionWithReducerIdGate,
  V as wrapActionsWithReducerIdGate
};
//# sourceMappingURL=index.es.js.map
